import React, { useEffect, useState } from "react"
import styled from "styled-components"

const Container = styled.div`
  padding-left: 20px;

  @media (max-width: ${props => props.theme.mediumBreakpoint}) {
    padding-left: 0px;
    padding-right: 10px;
  }

  @media (max-width: ${props => props.theme.mediumBreakpoint}) {
    display: none;
  }
`

const Title = styled.span`
  color: ${props => props.theme.primaryTextColor};
  font-family: ${props => props.theme.primaryFont};
  font-size: 16px;
  font-weight: 900;
  line-height: 16px;
  text-transform: uppercase;
  margin-bottom: 5px;
  margin-top: 5px;
  display: inline-block;
`
const ClearFilters = styled.span`
  color: ${props => props.theme.primaryColor};
  font-family: ${props => props.theme.primaryFont};
  font-size: 16px;
  line-height: 24px;
  font-weight: bold;
  /* text-align: center; */
  display: block;
  cursor: pointer;
`

const Label = styled.label`
  color: ${props => props.theme.primaryTextColor};
  font-family: ${props => props.theme.primaryFont};
  font-size: 13px;
  line-height: 16px;
  margin-left: 10px;
  cursor: pointer;
`

const Category = styled.div`
  margin-bottom: 15px;
  align-items: center;
  display: flex;
  flex-direction: row;
`

const Checkbox = styled.input`
  border: 1px solid #6b706a;
  background: #fff;
  color: #555;
  clear: none;
  cursor: pointer;
  display: inline-block;
  line-height: 1;
  height: 20px;
  margin: 0 4px 0 0;
  padding: 0;
  text-align: center;
  vertical-align: middle;
  width: 20px;
  -webkit-appearance: none;
  transition: 0.05s border-color ease-in-out;
  font-size: 16px;
  font-family: "themify";
  outline: none;

  &:checked {
    border: 1px solid ${props => props.theme.primaryColor};
    background: ${props => props.theme.primaryColor};
    color: white;

    &::before {
      content: "\\2713 ";
      vertical-align: middle;
    }
  }
`

const ProductCategorySearch = props => {
  return (
    <Container>
      {/* <Title>Category</Title> */}
      <div>
        {props.categories
          ? props.categories.map((category, index) => (
              <Category>
                {category.category == "Prang" || category.category == "Dixon" || category.category == "Ticonderoga" ? (
                  <Title>{category.category}</Title>
                ) : (
                  <>
                    <Checkbox
                      type="checkbox"
                      checked={category.active}
                      name={category.category}
                      id={category.category}
                      onChange={e => props.handleFilterChange(e, index)}
                    />
                    <Label for={category.category}>{category.category}</Label>
                  </>
                )}
              </Category>
            ))
          : null}
      </div>
      <ClearFilters onClick={props.clearFilters}>
        Clear All Filters
      </ClearFilters>
    </Container>
  )
}

export default ProductCategorySearch
